const PreProjects = () => import('./Index.vue')
const ReferralLinksDialog = () => import('./ReferralLinksDialog.vue')
const BudgetDialog = () => import('./../Finance/Budget/BudgetSimulator.vue')

export default [
  {
    name: 'pre-projects',
    path: 'pre-projects',
    component: PreProjects,
    meta: {
      access: ['org.preProject.view']
    },
    children: [
      {
        name: 'referral-links',
        path: 'referral-links',
        components: {
          modal: ReferralLinksDialog
        },
        meta: {
          showModal: true,
          access: ['org.preProject.manage']
        }
      },
      {
        name: 'budget-simulator',
        path: 'budget-simulator',
        components: {
          modal: BudgetDialog
        },
        meta: {
          showModal: true,
          access: ['org.budgetSimulator.view']
        }
      }
    ]
  }
]
